module.exports = __webpack_public_path__ + "img/002-beef.aa9cde16.svg";